import { render, staticRenderFns } from "./smsMontant.vue?vue&type=template&id=2c180cd1"
import script from "./smsMontant.vue?vue&type=script&lang=js"
export * from "./smsMontant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports